/* ------------------------------------------------------------------
   GarmentFlow marketing site behaviour.

   The first half is gf-chrome.js as the Builder pages served it: the
   responsive nav, the language switcher and the contact form. The second
   half replaces the small per-page <script> tags those pages inlined.

   Nothing here reveals content — the source CSS force-shows .reveal, so
   every page reads fine with JavaScript switched off, which is what we
   want a crawler to see.
   ------------------------------------------------------------------ */

/* GarmentFlow shared chrome: language switch + responsive nav. Single source. */
(function () {
	if (window.__GFCHROME__) return;
	window.__GFCHROME__ = 1;
	var SUP = ["es", "pt", "zh"];
	var GF_T = {
		en: {
			done: "Got it — your message is threaded through to our team. 🧵 Someone from GarmentFlow will be in touch with you soon.",
			trust: "A human reads every message — no spam, ever.",
			miss: "Please add your name, email and a message.",
			bad: "That email doesn’t look right — mind checking it?",
			send: "Sending…",
			err: 'Something went wrong on our end. You can email us directly at <strong>ashah@garmentflow.io</strong>.<div style="margin-top:10px"><a href="mailto:ashah@garmentflow.io?subject=GarmentFlow%20enquiry" style="display:inline-block;background:#17304d;color:#fff;text-decoration:none;padding:9px 16px;border-radius:10px;font-size:13px;font-weight:600">Email us</a></div>',
		},
		es: {
			done: "¡Listo! Tu mensaje ya está en manos de nuestro equipo. 🧵 Alguien de GarmentFlow se pondrá en contacto contigo muy pronto.",
			trust: "Una persona real lee cada mensaje. Sin spam, nunca.",
			miss: "Por favor, indica tu nombre, correo y un mensaje.",
			bad: "Ese correo no parece válido, ¿puedes revisarlo?",
			send: "Enviando…",
			err: 'Algo salió mal de nuestro lado. Puedes escribirnos directamente a <strong>ashah@garmentflow.io</strong>.<div style="margin-top:10px"><a href="mailto:ashah@garmentflow.io?subject=Consulta%20GarmentFlow" style="display:inline-block;background:#17304d;color:#fff;text-decoration:none;padding:9px 16px;border-radius:10px;font-size:13px;font-weight:600">Escríbenos</a></div>',
		},
		pt: {
			done: "Tudo certo! A sua mensagem já está com a nossa equipa. 🧵 Alguém da GarmentFlow entrará em contacto consigo em breve.",
			trust: "Uma pessoa real lê cada mensagem. Sem spam, nunca.",
			miss: "Por favor, indique o seu nome, email e uma mensagem.",
			bad: "Esse email não parece válido — pode verificar?",
			send: "A enviar…",
			err: 'Algo correu mal do nosso lado. Pode escrever-nos diretamente para <strong>ashah@garmentflow.io</strong>.<div style="margin-top:10px"><a href="mailto:ashah@garmentflow.io?subject=Contacto%20GarmentFlow" style="display:inline-block;background:#17304d;color:#fff;text-decoration:none;padding:9px 16px;border-radius:10px;font-size:13px;font-weight:600">Envie-nos um email</a></div>',
		},
		zh: {
			done: "收到！您的消息已转交给我们的团队。🧵 GarmentFlow 的同事会尽快与您联系。",
			trust: "每条消息都有真人阅读，绝不发送垃圾邮件。",
			miss: "请填写您的姓名、电子邮箱和留言。",
			bad: "邮箱地址似乎不正确，请检查一下。",
			send: "发送中…",
			err: '我们这边出了点问题。您可以直接发邮件至 <strong>ashah@garmentflow.io</strong>。<div style="margin-top:10px"><a href="mailto:ashah@garmentflow.io?subject=GarmentFlow" style="display:inline-block;background:#17304d;color:#fff;text-decoration:none;padding:9px 16px;border-radius:10px;font-size:13px;font-weight:600">给我们发邮件</a></div>',
		},
	};
	function GFT() {
		return GF_T[cur] || GF_T.en;
	}
	function gfDoneHTML() {
		return (
			'<div style="padding:26px 24px;background:var(--beige,#f4f1ec);border-radius:16px;font-size:17px;line-height:1.5;color:var(--ink,#1a1a1a)">' +
			GFT().done +
			"</div>"
		);
	}
	function gfHoney(f) {
		var h = document.createElement("input");
		h.type = "text";
		h.name = "website_url";
		h.tabIndex = -1;
		h.setAttribute("autocomplete", "off");
		h.setAttribute("aria-hidden", "true");
		h.style.cssText =
			"position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none";
		f.appendChild(h);
		return h;
	}
	function gfNote(f) {
		var btn = f.querySelector('button[type="submit"]') || f.querySelector("button");
		if (!btn || f.querySelector(".gf-trust")) return;
		var p = document.createElement("p");
		p.className = "gf-trust";
		p.style.cssText =
			"margin:14px 0 0;font-size:12px;letter-spacing:.04em;color:var(--ink-soft,#6b7280)";
		p.textContent = GFT().trust;
		btn.parentNode.insertBefore(p, btn.nextSibling);
	}
	function wireContact() {
		[].forEach.call(document.querySelectorAll("form.contact-form:not([data-gf-demo])"), function (f) {
			if (f.__gfw) return;
			f.__gfw = 1;
			var hp = gfHoney(f);
			gfNote(f);
			f.addEventListener("submit", function (e) {
				if (e && e.preventDefault) e.preventDefault();
				var t = GFT();
				var val = function (n) {
					var el = f.querySelector('[name="' + n + '"]');
					return el ? (el.value || "").trim() : "";
				};
				var name = val("name"),
					email = val("email"),
					company = val("company"),
					message = val("message");
				var btn = f.querySelector('button[type="submit"]') || f.querySelector("button");
				var err = f.querySelector(".gf-err");
				function showErr(m) {
					if (!err) {
						err = document.createElement("div");
						err.className = "gf-err";
						err.style.cssText =
							"margin-top:12px;font-size:14px;color:#b42318;background:#fef3f2;border-radius:12px;padding:12px 14px";
						if (btn) btn.parentNode.insertBefore(err, btn.nextSibling);
						else f.appendChild(err);
					}
					err.innerHTML = m;
				}
				if (hp && hp.value) {
					f.innerHTML = gfDoneHTML();
					return false;
				}
				if (!name || !email || !message) {
					showErr(t.miss);
					return false;
				}
				if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
					showErr(t.bad);
					return false;
				}
				var data = {
					doctype: "CRM Lead",
					web_form_name: "contact-garmentflow",
					first_name: name,
					email: email,
					organization: company,
					custom_message: message,
					source: "Website",
					custom_language: cur || "en",
				};
				var body =
					"web_form=contact-garmentflow&data=" +
					encodeURIComponent(JSON.stringify(data));
				var os = btn ? btn.innerHTML : "";
				if (btn) {
					btn.disabled = true;
					btn.innerHTML = "<span>" + t.send + "</span>";
				}
				fetch("/api/method/frappe.website.doctype.web_form.web_form.accept", {
					method: "POST",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
						Accept: "application/json",
						"X-Frappe-CSRF-Token": (window.frappe && window.frappe.csrf_token) || "",
					},
					body: body,
				})
					.then(function (r) {
						if (!r.ok) throw r;
						return r.json().catch(function () {
							return {};
						});
					})
					.then(function () {
						f.innerHTML = gfDoneHTML();
					})
					.catch(function () {
						if (btn) {
							btn.disabled = false;
							btn.innerHTML = os;
						}
						showErr(t.err);
					});
				return false;
			});
		});
	}
	var CSS = `
.nav-burger{display:none;margin-left:auto;background:none;border:0;cursor:pointer;width:42px;height:42px;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:9px;color:inherit}
.nav-burger span{display:block;height:2px;width:22px;background:currentColor;border-radius:2px;transition:transform .2s,opacity .2s}
@media(max-width:860px){
 .nav .nav-inner{flex-wrap:wrap;align-items:center}
 .nav-burger{display:flex}
 .nav .nav-links,.nav .nav-tools{display:none}
 .nav.nav-open{height:auto;max-height:100vh;overflow-y:auto;padding-bottom:12px;background:#fff}
 .theme-dark .nav.nav-open{background:#16263c}
 .nav.nav-open .nav-links{display:flex;flex-direction:column;width:100%;gap:0;margin-top:6px}
 .nav.nav-open .nav-tools{display:flex;flex-wrap:wrap;align-items:center;gap:16px;width:100%;margin-top:8px;padding-top:12px;border-top:1px solid rgba(0,0,0,.12)}
 .theme-dark .nav.nav-open .nav-tools{border-top-color:rgba(255,255,255,.15)}
 .nav .nav-links li{width:100%;list-style:none}
 .nav .nav-links>li>a{display:block;padding:12px 4px;font-size:16px}
 .nav .nav-links .has-drop>a{pointer-events:none;opacity:.6;font-size:12px;text-transform:uppercase;letter-spacing:.06em;padding-bottom:2px}
 .nav.nav-open .nav-links .dropdown{position:static;display:block;opacity:1!important;visibility:visible!important;transform:none!important;box-shadow:none;border:0;background:none;padding:0 0 8px 14px;min-width:0}
 .nav.nav-open .nav-links .dropdown li a{padding:9px 4px;font-size:15px;opacity:1;letter-spacing:normal;text-transform:none}
 .nav.nav-open .lang.has-drop{width:100%;position:relative}
 .nav.nav-open .lang .lang-menu{position:static;display:block;opacity:1!important;visibility:visible!important;transform:none!important;box-shadow:none;border:0;background:none;padding:4px 0 0 0}
 .nav.nav-open .nav-cta{margin-top:6px}
 .nav.nav-open .nav-burger span:nth-child(1){transform:translateY(7px) rotate(45deg)}
 .nav.nav-open .nav-burger span:nth-child(2){opacity:0}
 .nav.nav-open .nav-burger span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}
}`;
	function injectCSS() {
		var s = document.createElement("style");
		s.textContent = CSS;
		document.head.appendChild(s);
	}
	function segs() {
		return location.pathname
			.replace(/^\/+|\/+$/g, "")
			.split("/")
			.filter(Boolean);
	}
	var s0 = segs();
	var cur = SUP.indexOf(s0[0]) >= 0 ? s0[0] : "en";
	var isDocs = s0[0] === "docs" || (SUP.indexOf(s0[0]) >= 0 && s0[1] === "docs");
	function noPfx(h) {
		return /^\/(lms|learn|helpdesk)(\/|$|\?|#)/.test(h);
	}
	/* Which routes actually exist in every language, rendered into the page by
	   templates/includes/marketing_nav.html from i18n.TRANSLATED_ROUTES.

	   This used to be "everything except /lms, /learn and /helpdesk", which was wishful:
	   on a Spanish page it rewrote /login, /signup, /refunds and even the language
	   switcher's own /api/method/... URL to /es/..., and every one of those is a 404.
	   Only the marketing routes have translations, so only they may be prefixed. */
	var GFROUTES = null;
	function translated(h) {
		if (GFROUTES === null) {
			GFROUTES = [];
			try {
				var el = document.getElementById("gfLocaleRoutes");
				if (el) GFROUTES = JSON.parse(el.textContent) || [];
			} catch (e) {
				/* no list rendered — prefix nothing rather than guess */
			}
		}
		// Compare the path alone: /signup?plan=x is still /signup.
		var path = String(h || "").split(/[?#]/)[0].replace(/\/+$/, "") || "/";
		var p = path.split("/").filter(Boolean);
		if (SUP.indexOf(p[0]) >= 0) p = p.slice(1);
		path = "/" + p.join("/");
		return GFROUTES.indexOf(path) >= 0;
	}
	/* The English home page is "/", not "/home" — that route does not exist and the
	   picker had been offering it as a 404 to anybody switching back to English from the
	   front page. Spanish home is "/es", with no trailing slash. */
	function loc(path, l) {
		var p = path.replace(/^\/+/, "").split("/").filter(Boolean);
		if (SUP.indexOf(p[0]) >= 0) p = p.slice(1);
		var c = "/" + p.join("/");
		if (l === "en") return c;
		return c === "/" ? "/" + l : "/" + l + c;
	}
	function dhome(l) {
		return l === "en" ? "/docs" : "/" + l + "/docs";
	}
	function base() {
		var p = segs();
		if (SUP.indexOf(p[0]) >= 0) p = p.slice(1);
		return "/" + p.join("/");
	}
	function burger() {
		var nav = document.querySelector("nav.nav");
		if (!nav) return;
		var inner = nav.querySelector(".nav-inner");
		if (!inner || inner.__gfb) return;
		inner.__gfb = 1;

		// The markup carries the button now. This used to bail out the moment it found
		// one — `if (inner.querySelector(".nav-burger")) return;` — which was written to
		// avoid making a second button and instead skipped wiring the first, so the
		// menu button on every page did nothing at all on a phone. Take the button that
		// is there; build one only if the template did not supply it.
		var b = inner.querySelector(".nav-burger");
		if (!b) {
			b = document.createElement("button");
			b.type = "button";
			b.className = "nav-burger";
			b.setAttribute("aria-label", "Toggle menu");
			b.innerHTML = "<span></span><span></span><span></span>";
			var logo = inner.querySelector(".nav-logo");
			if (logo && logo.nextSibling) inner.insertBefore(b, logo.nextSibling);
			else inner.appendChild(b);
		}

		function setOpen(v) {
			nav.classList.toggle("nav-open", v);
			b.setAttribute("aria-expanded", v ? "true" : "false");
		}
		setOpen(false);

		b.addEventListener("click", function () {
			setOpen(!nav.classList.contains("nav-open"));
		});
		inner.addEventListener("click", function (e) {
			var a = e.target.closest("a");
			if (a) {
				var h = a.getAttribute("href");
				if (h && h !== "#") setOpen(false);
			}
		});
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && nav.classList.contains("nav-open")) {
				setOpen(false);
				b.focus();
			}
		});
	}

	/* -- "Start Designing for Free", on the bar only when the bar has room -------------
	   The bar was full before this button existed, and how much room is left depends on
	   the language — the Portuguese and Spanish labels run about 180px wider than the
	   English ones — so no breakpoint can decide it. Measure instead: put the button on,
	   and if the tools now spill past the container, take it back off. The Features menu
	   and the open phone menu carry the same link at every width, so nobody loses the
	   door; only the shortcut comes and goes. */
	function freeDoor() {
		var nav = document.querySelector(".nav");
		var inner = nav && nav.querySelector(".nav-inner");
		var tools = inner && inner.querySelector(".nav-tools");
		var burger = inner && inner.querySelector(".nav-burger");
		if (!tools || !inner.querySelector(".nav-cta--free") || nav.__gfFree) return;
		nav.__gfFree = 1;

		function fit() {
			// On a phone the button lives in the menu the burger opens; the bar is not
			// measured, and never shows it.
			if (nav.classList.contains("nav-open") || (burger && getComputedStyle(burger).display !== "none")) {
				nav.classList.remove("nav--roomy");
				return;
			}
			nav.classList.add("nav--roomy");
			var edge = inner.getBoundingClientRect().right - parseFloat(getComputedStyle(inner).paddingRight);
			if (tools.getBoundingClientRect().right > edge + 0.5) nav.classList.remove("nav--roomy");
		}

		var t;
		fit();
		window.addEventListener("resize", function () {
			clearTimeout(t);
			t = setTimeout(fit, 120);
		});
		// The labels are measured in whatever font has arrived; measure again once the
		// real one has, or a fallback face decides the layout for the page's lifetime.
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
	}

	/* -- the features mega-menu -------------------------------------------------------
	   Three columns on a desktop, the same three groups as a stacked accordion on a
	   phone. One panel, one open/close, so the keyboard and the pointer cannot end up
	   disagreeing about whether it is showing. */
	function mega() {
		var btn = document.getElementById("megaBtn");
		var panel = document.getElementById("megaFeatures");
		if (!btn || !panel || btn.__gfm) return;
		btn.__gfm = 1;

		var item = btn.parentNode;
		var narrow = window.matchMedia("(max-width: 860px)");
		var byClick = false;
		var closing = null;

		function setOpen(v) {
			panel.hidden = !v;
			btn.setAttribute("aria-expanded", v ? "true" : "false");
			if (!v) byClick = false;
		}
		setOpen(false);

		btn.addEventListener("click", function () {
			var opening = panel.hidden;
			setOpen(opening);
			// A menu somebody opened deliberately stays open until they close it
			// deliberately. Before this, clicking it open and then moving the pointer
			// off the button shut it again mid-reach.
			byClick = opening;
		});

		/* Hover, where hovering is a real thing. On a touch screen the first tap would
		   open and the synthetic mouseleave would shut it again.

		   The panel hangs 16px below the button — it is positioned against the nav bar,
		   not the button — and it is out of flow, so it adds nothing to the <li>'s box.
		   Moving the pointer down towards a link therefore left the <li> and closed the
		   menu before the pointer ever arrived. Two fixes, together: the panel counts as
		   part of the menu for hover purposes, and leaving grants a short grace period so
		   crossing the gap does not read as leaving. */
		if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
			var hold = function () {
				clearTimeout(closing);
				closing = null;
			};
			var release = function () {
				if (narrow.matches || byClick) return;
				clearTimeout(closing);
				closing = setTimeout(function () {
					setOpen(false);
				}, 220);
			};

			[item, panel].forEach(function (el) {
				el.addEventListener("mouseenter", function () {
					hold();
					if (!narrow.matches && panel.hidden) setOpen(true);
				});
				el.addEventListener("mouseleave", release);
			});
		}

		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && !panel.hidden) {
				clearTimeout(closing);
				setOpen(false);
				btn.focus();
			}
		});
		// Clicking away, or tabbing away, closes it.
		["click", "focusin"].forEach(function (evt) {
			document.addEventListener(evt, function (e) {
				if (panel.hidden) return;
				if (btn.contains(e.target) || panel.contains(e.target)) return;
				clearTimeout(closing);
				setOpen(false);
			});
		});

		/* -- accordion, phone only -- */
		var cols = [].slice.call(panel.querySelectorAll(".mega-col"));
		function syncAccordion() {
			cols.forEach(function (col, i) {
				var h = col.querySelector(".mega-h");
				var list = col.querySelector("ul");
				if (!h || !list) return;
				var toggle = h.querySelector("button");

				if (narrow.matches) {
					if (toggle) return;
					if (!list.id) list.id = "megaCol" + i;
					var t = document.createElement("button");
					t.type = "button";
					t.className = "mega-h__toggle";
					t.textContent = (h.textContent || "").trim();
					t.setAttribute("aria-controls", list.id);
					t.setAttribute("aria-expanded", "false");
					list.hidden = true;
					h.textContent = "";
					h.appendChild(t);
					t.addEventListener("click", function () {
						var opening = list.hidden;
						list.hidden = !opening;
						t.setAttribute("aria-expanded", opening ? "true" : "false");
					});
				} else if (toggle) {
					h.textContent = toggle.textContent;
					list.hidden = false;
				}
			});
		}
		syncAccordion();
		if (narrow.addEventListener) narrow.addEventListener("change", syncAccordion);
		else if (narrow.addListener) narrow.addListener(syncAccordion);
	}

	/* -- the one contact form ---------------------------------------------------------
	   Every door page and the homepage include templates/includes/demo_form.html, which
	   posts a GF Demo Request — the doctype somebody actually watches — carrying the
	   page that produced it. The older Builder pages still post a CRM Lead through
	   wireContact() above; both can be on the site at once, which is why the selectors
	   are exclusive. */
	function wireDemo() {
		[].forEach.call(document.querySelectorAll("form[data-gf-demo]"), function (f) {
			if (f.__gfd) return;
			f.__gfd = 1;
			gfNote(f);

			f.addEventListener("submit", function (e) {
				e.preventDefault();
				var t = GFT();
				var val = function (n) {
					var el = f.querySelector('[name="' + n + '"]');
					return el ? (el.value || "").trim() : "";
				};
				var btn = f.querySelector('button[type="submit"]') || f.querySelector("button");
				var err = f.querySelector(".gf-err");
				function showErr(m) {
					if (!err) {
						err = document.createElement("div");
						err.className = "gf-err";
						err.setAttribute("role", "alert");
						if (btn) btn.parentNode.insertBefore(err, btn.nextSibling);
						else f.appendChild(err);
					}
					err.innerHTML = m;
				}

				// The honeypot is answered, not argued with: a bot that filled it gets
				// the same success screen a person gets and nothing is written anywhere.
				if (val("website_url")) {
					f.innerHTML = gfDoneHTML();
					return;
				}
				if (!val("full_name") || !val("email")) {
					showErr(t.miss);
					return;
				}
				if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val("email"))) {
					showErr(t.bad);
					return;
				}

				var args = {
					full_name: val("full_name"),
					email: val("email"),
					company: val("company"),
					phone: val("phone"),
					operators: val("operators"),
					message: val("message"),
					// The hidden field carries the route this copy of the form was
					// rendered on; location.search carries whatever campaign sent them
					// here. The server splits the two again and keeps only the utm_*
					// parameters, so a long analytics tail costs nothing here.
					source_page: (val("source_page") || location.pathname) + location.search,
					website_url: "",
				};
				var body = Object.keys(args)
					.map(function (k) {
						return encodeURIComponent(k) + "=" + encodeURIComponent(args[k]);
					})
					.join("&");

				var os = btn ? btn.innerHTML : "";
				if (btn) {
					btn.disabled = true;
					btn.innerHTML = "<span>" + t.send + "</span>";
				}

				fetch("/api/method/garmentflow_cloud.demo.request_demo", {
					method: "POST",
					credentials: "same-origin",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
						Accept: "application/json",
						"X-Frappe-CSRF-Token": (window.frappe && window.frappe.csrf_token) || "",
					},
					body: body,
				})
					.then(function (r) {
						if (!r.ok) throw r;
						return r.json().catch(function () {
							return {};
						});
					})
					.then(function () {
						// Inline, in place. A redirect would lose which page they were
						// reading, which is the whole reason the form is on every page.
						f.innerHTML = gfDoneHTML();
					})
					.catch(function () {
						if (btn) {
							btn.disabled = false;
							btn.innerHTML = os;
						}
						showErr(t.err);
					});
			});
		});
	}
	function lang() {
		var MAP = { English: "en", Español: "es", Português: "pt", 中文: "zh" };
		document.querySelectorAll(".lang-menu a").forEach(function (a) {
			var l = MAP[(a.textContent || "").trim()];
			if (!l) return;
			a.setAttribute("href", isDocs ? dhome(l) : loc(base(), l));
			a.dataset.gfl = "1";
			a.addEventListener("click", function () {
				try {
					localStorage.setItem("gf-lang", l);
					// Marks this session as "the visitor has decided", which switches the
					// browser-language guess off for good.
					sessionStorage.setItem("gf-chose", "1");
				} catch (e) {
					/* storage refused — the preference simply is not remembered */
				}
			});
		});
		var btn = document.querySelector(".lang-btn");
		if (btn) btn.innerHTML = btn.innerHTML.replace(/EN|ES|PT|ZH/, cur.toUpperCase());
		if (cur !== "en") {
			document.querySelectorAll('a[href^="/"]').forEach(function (a) {
				if (a.dataset.gfl) return;
				if (a.closest && a.closest(".lang-menu")) return;
				var h = a.getAttribute("href");
				if (!h || h.charAt(0) !== "/") return;
				a.dataset.gfl = "1";
				if (noPfx(h) || !translated(h)) return;
				a.setAttribute("href", loc(h, cur));
			});
		} else {
			/* An English page. Two things happen here, and the order matters.

			   Being on an un-prefixed route is itself a choice of English — the visitor
			   either clicked "English" or followed an English link — so record it. Before
			   this, choosing English left `gf-lang` on its previous value, and the guess
			   below then sent them straight back to the language they had just left. The
			   sessionStorage guard hid it after the first bounce, so it read as "the
			   switcher works sometimes".

			   Then, and only for somebody with no stored preference at all, guess once
			   from the browser. A visitor who has ever chosen is never redirected again:
			   the URL they are on is the answer. */
			try {
				localStorage.setItem("gf-lang", "en");
			} catch (e) {
				/* storage refused — the preference simply is not remembered */
			}

			var chosen = null,
				redirected = null;
			try {
				chosen = sessionStorage.getItem("gf-chose");
			} catch (e) {
				/* storage refused — treat as a first visit */
			}
			try {
				redirected = sessionStorage.getItem("gf-redir");
			} catch (e) {
				/* storage refused — treat as not yet redirected */
			}

			if (!chosen && !redirected && translated(location.pathname)) {
				var n = (navigator.language || navigator.userLanguage || "")
					.slice(0, 2)
					.toLowerCase();
				if (SUP.indexOf(n) >= 0 && n !== "en") {
					try {
						sessionStorage.setItem("gf-redir", "1");
					} catch (e) {
						/* storage refused — the guess may repeat next page */
					}
					location.replace(isDocs ? dhome(n) : loc(base(), n));
				}
			}
		}
	}
	function contactDest() {
		if (document.querySelector("form.contact-form")) return "#contact";
		return cur && cur !== "en" ? "/" + cur + "/contact-us" : "/contact-us";
	}
	function footerLinks() {
		var dest = contactDest();
		[].forEach.call(
			document.querySelectorAll('a[href="#contact"], a[href$="/contact"]'),
			function (a) {
				a.setAttribute("href", dest);
				a.dataset.gfl = "1";
			}
		);
		var f = document.querySelector("footer");
		if (f) {
			var M = {
				contact: dest,
				"contact us": dest,
				"contact us ": dest,
				// The page is /privacy. /privacy-policy has never existed, so this was
				// rewriting the footer's Privacy link to a 404 on every page of the site.
				privacy: "/privacy",
				"privacy policy": "/privacy",
				terms: "/terms",
				"terms & conditions": "/terms",
				"terms and conditions": "/terms",
			};
			[].forEach.call(f.querySelectorAll("a"), function (a) {
				var t = (a.textContent || "").trim().toLowerCase();
				if (M[t]) {
					a.setAttribute("href", M[t]);
					a.dataset.gfl = "1";
				}
			});
		}
	}
	/* -- screens: the only motion on the site -----------------------------------------

	   One IntersectionObserver does both jobs, because they are the same event: a screen
	   entering the viewport rises 8px and sharpens, and if it is a recording it starts
	   playing. Leaving pauses it again — four looping clips on a homepage that all keep
	   decoding after you have scrolled past is most of what makes a page like this feel
	   heavy, and it is invisible in a screenshot.

	   Recordings are authored `preload="none"` with no `autoplay` attribute, so nothing
	   is fetched beyond the poster until somebody actually scrolls to it.

	   prefers-reduced-motion: the class is still added (the CSS neutralises the
	   transition) and the clip is never played — the poster frame is the whole thing,
	   which is why every recording must have one. */
	function screens() {
		var items = [].slice.call(document.querySelectorAll(".reveal-media"));
		if (!items.length) return;

		var still =
			window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		function clipIn(el) {
			return el.matches("video[data-gf-clip]") ? el : el.querySelector("video[data-gf-clip]");
		}

		// No observer (old browser, or a crawler): show everything, play nothing.
		if (!("IntersectionObserver" in window)) {
			items.forEach(function (el) {
				el.classList.add("in");
			});
			return;
		}

		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (e) {
					var el = e.target;
					var clip = clipIn(el);

					if (e.isIntersecting) {
						el.classList.add("in");
						if (!clip || still) return;
						// Browsers only honour autoplay on a muted element, and Safari
						// wants the attribute as well as the property. A viewer who turned
						// the sound on (the hero film has controls) keeps it: scrolling
						// away and back is not a request to be muted again.
						if (!clip.dataset.gfHeard) {
							clip.muted = true;
							clip.setAttribute("muted", "");
						}
						if (clip.preload === "none") clip.preload = "auto";
						if (clip.play) clip.play().catch(function () {});
					} else if (clip && clip.pause && !clip.paused) {
						clip.pause();
					}
				});
			},
			{ rootMargin: "150px 0px" }
		);

		items.forEach(function (el) {
			io.observe(el);
			var clip = clipIn(el);
			if (clip) {
				clip.addEventListener("volumechange", function () {
					if (!clip.muted) clip.dataset.gfHeard = "1";
				});
			}
		});
	}

	/* -- the language dropdown ---------------------------------------------------------

	   This was CSS `:hover` and nothing else: `.has-drop:hover .dropdown`. On a desktop
	   with a mouse it opened; on a phone or tablet — where there is no hover — the
	   language switcher could not be opened at all, and `aria-expanded` on the button
	   never changed, so a screen reader was told it was permanently collapsed.

	   Same treatment the Features menu got: click to toggle, hover still opens it on a
	   pointer device, Escape closes and returns focus, clicking away closes. The CSS
	   hover rule stays for pointer users; `.lang-open` is what click adds. */
	function langMenu() {
		var wrap = document.querySelector(".lang.has-drop");
		if (!wrap || wrap.__gfl) return;
		var btn = wrap.querySelector(".lang-btn");
		var menu = wrap.querySelector(".lang-menu");
		if (!btn || !menu) return;
		wrap.__gfl = 1;

		function setOpen(v) {
			wrap.classList.toggle("lang-open", !!v);
			btn.setAttribute("aria-expanded", v ? "true" : "false");
		}
		setOpen(false);

		btn.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			setOpen(!wrap.classList.contains("lang-open"));
		});

		// Choosing a language navigates; nothing to keep open afterwards.
		menu.addEventListener("click", function (e) {
			if (e.target.closest("a")) setOpen(false);
		});

		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && wrap.classList.contains("lang-open")) {
				setOpen(false);
				btn.focus();
			}
		});

		["click", "focusin"].forEach(function (evt) {
			document.addEventListener(evt, function (e) {
				if (!wrap.classList.contains("lang-open")) return;
				if (wrap.contains(e.target)) return;
				setOpen(false);
			});
		});
	}

	function run() {
		injectCSS();
		footerLinks();
		wireContact();
		wireDemo();
		burger();
		mega();
		freeDoor();
		lang();
		langMenu();
		screens();
	}
	if (document.readyState !== "loading") run();
	else document.addEventListener("DOMContentLoaded", run);
})();

/* ---- background clips ---------------------------------------------------
   These autoplayed on load with preload="auto", so every visitor downloaded
   every clip immediately — 2.9 MB on /logistics alone, before scrolling.
   They now carry preload="none" and start only once they are near the
   viewport. Browsers honour autoplay only on a muted element, and the
   attribute has to be set from JS too for Safari.

   prefers-reduced-motion is respected: the clip stays on its first frame
   rather than looping.
   -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
	var clips = [].slice.call(document.querySelectorAll("video[data-gf-autoplay]"));
	if (!clips.length) return;

	var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function start(v) {
		v.muted = true;
		v.setAttribute("muted", "");
		if (still) {
			v.removeAttribute("loop");
			v.preload = "metadata";
			return;
		}
		v.preload = "auto";
		if (v.play) v.play().catch(function () {});
	}

	if (!("IntersectionObserver" in window)) {
		clips.forEach(start);
		return;
	}

	var io = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (e) {
				if (!e.isIntersecting) return;
				io.unobserve(e.target);
				start(e.target);
			});
		},
		{ rootMargin: "200px" }
	);

	clips.forEach(function (v) {
		io.observe(v);
	});
});

/* ---- pricing configurator ----------------------------------------------
   The operator count sets the floor; everything above it is a choice.

   A visitor says how many people record work on their floor, which lands them
   on the smallest plan that can hold them. From there the page asks, one tier
   at a time, whether they want what the next tier adds — because a small
   factory may well want quality inspection or machine maintenance, and the
   only way to buy those is to move up a gate.

   Every question can be declined. Only the step you are on is shown, and
   answering it — either way — opens the next. Until an operator count is typed
   the configurator is just its question, and the summary waits until the last
   step is answered, so the top of the page stays short for somebody who is only
   reading.

   Nothing here is written down. The plans, the features each grants, the
   difference between neighbouring tiers, the price of that difference and the
   copy that sells it all come out of GF Plan and GF Feature, rendered into
   #gfPlanFinder by pricing.py. The sell copy is the feature's own "Shown When
   Locked" content, so the upsell on this page and the upsell inside the
   product are the same words, edited in one place.

   Tiers are cumulative: taking a step selects that plan and every step below
   it, and dropping one falls back a tier, never below the operator floor.
   ------------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
	var source = document.getElementById("gfPlanFinder");
	var input = document.getElementById("cfgOps");
	var stepHost = document.getElementById("cfgSteps");
	if (!source || !input || !stepHost) return;
	var shell = input.closest(".config");
	var bar = document.getElementById("cfgBar");
	var summary = document.getElementById("cfgSummary");

	var data;
	try {
		data = JSON.parse(source.textContent);
	} catch (e) {
		// A page that cannot parse its own plans keeps the server-rendered free plan,
		// which is complete and correct — better than an empty panel.
		return;
	}
	if (!data || !data.plans || !data.plans.length) return;

	var plans = data.plans;
	var text = data.text || {};
	var detail = {};
	(data.features || []).forEach(function (f) {
		detail[f.key] = f;
	});

	var el = {};
	[
		"cfgBadge", "cfgName", "cfgBand", "cfgPrice", "cfgPer",
		"cfgSumName", "cfgSumPrice", "cfgSumPer", "cfgFeatures", "cfgCta", "cfgNote",
		"cfgStageImg", "cfgStageEmpty", "cfgStageCap",
		"cfgBarName", "cfgBarPrice", "cfgBarPer", "cfgBarCta",
	].forEach(function (id) {
		el[id] = document.getElementById(id);
	});

	// floor    — the smallest plan the operator count allows; the lower bound on choice.
	// chosen   — where they are now, always at or above the floor.
	// answered — the highest step index that has been answered either way. Everything
	//            past it is still locked.
	var floor = 0;
	var chosen = 0;
	var answered = -1;
	// The step whose confirmation is showing, and the timer that moves us past it.
	var flashed = -1;
	var advancing = null;

	function fill(template, value) {
		return String(template || "").replace("{0}", value);
	}

	function esc(value) {
		var d = document.createElement("div");
		d.textContent = value == null ? "" : String(value);
		return d.innerHTML;
	}

	/* Which plan an operator count lands on.

	   `max` is the top of a plan's band, and 0 means "no ceiling" — the free plan sits
	   below every band and the quote-only plan above all of them, so neither can be
	   matched by comparing against it. */
	function floorFor(ops) {
		if (!(ops > 0)) {
			for (var f = 0; f < plans.length; f++) if (plans[f].free) return f;
			return 0;
		}
		var best = -1;
		for (var i = 0; i < plans.length; i++) {
			var plan = plans[i];
			if (plan.free || plan.unbounded || !(plan.max > 0)) continue;
			if (ops <= plan.max && (best < 0 || plan.max < plans[best].max)) best = i;
		}
		if (best >= 0) return best;
		// Past every band: the quote-only plan, or failing that the largest one there is.
		for (var u = 0; u < plans.length; u++) if (plans[u].unbounded) return u;
		return plans.length - 1;
	}

	/* What moving from one tier to the next actually adds. Set difference, in matrix
	   order, and the reason an upsell can never name something the plan does not grant. */
	function gains(from, to) {
		var had = {};
		plans[from].includes.forEach(function (key) {
			had[key] = true;
		});
		return plans[to].includes.filter(function (key) {
			return !had[key] && detail[key];
		});
	}

	/* The tiers worth asking about: above the floor, adding something, and priced. */
	function ladder() {
		var rungs = [];
		for (var to = floor + 1; to < plans.length; to++) {
			var added = gains(to - 1, to);
			if (added.length && plans[to].step) rungs.push({ to: to, added: added });
		}
		return rungs;
	}

	function setStage(feature) {
		if (!el.cfgStageImg) return;
		var media = feature && feature.media;
		// A .webp/.png/.jpg is a screenshot we can show. Anything else — a video page,
		// a link — is not something to put in an <img>, so the panel stays on its
		// wordmark rather than rendering a broken frame.
		var isImage = media && /\.(png|jpe?g|webp|gif|avif|svg)(\?|$)/i.test(media);
		el.cfgStageImg.hidden = !isImage;
		if (isImage) el.cfgStageImg.setAttribute("src", media);
		if (el.cfgStageEmpty) el.cfgStageEmpty.hidden = !!isImage;
		if (el.cfgStageCap) el.cfgStageCap.textContent = feature ? feature.label : "";
	}

	function paintPanels() {
		var plan = plans[chosen];
		var pairs = [
			["cfgName", plan.name], ["cfgBand", plan.band],
			["cfgPrice", plan.price], ["cfgPer", plan.period],
			["cfgSumName", plan.name], ["cfgSumPrice", plan.price], ["cfgSumPer", plan.period],
			["cfgNote", plan.note || ""],
			["cfgBarName", plan.name], ["cfgBarPer", plan.period],
		];
		pairs.forEach(function (pair) {
			if (el[pair[0]]) el[pair[0]].textContent = pair[1];
		});
		// The bar's price holds the period inside it, so write around the child rather
		// than over it.
		if (el.cfgBarPrice && el.cfgBarPer) {
			el.cfgBarPrice.firstChild.nodeValue = plan.price;
		}
		if (el.cfgBadge) {
			el.cfgBadge.textContent = plan.badge || "";
			el.cfgBadge.hidden = !plan.badge;
		}
		[el.cfgCta, el.cfgBarCta].forEach(function (cta) {
			if (!cta) return;
			cta.textContent = plan.cta;
			cta.setAttribute("href", plan.url);
		});
		if (el.cfgFeatures) {
			el.cfgFeatures.innerHTML = plan.includes
				.map(function (key) {
					var f = detail[key];
					if (!f) return "";
					return (
						"<li><b>" + esc(f.label) + "</b>" +
						(f.detail ? "<span>" + esc(f.detail) + "</span>" : "") + "</li>"
					);
				})
				.join("");
		}
	}

	function stepMarkup(rung, index) {
		var to = rung.to;
		var head = detail[rung.added[0]];
		var rest = rung.added.slice(1);
		var locked = index > answered + 1;
		var taken = chosen >= to;
		var refused = index <= answered && !taken;

		var state = locked ? "locked" : taken ? "yes" : refused ? "no" : "open";
		var html =
			'<section class="cfgstep cfgstep--' + state + '" data-step="' + index + '" data-to="' + to + '">' +
			'<h2 class="cfgstep__h"><b>' + esc(head.label) + '.</b> <span>' +
			esc(locked ? text.locked : taken ? text.added : refused ? text.declined : text.need) +
			"</span></h2>";

		// Not reached yet: not shown. It appears when the step above it is answered.
		if (locked) return "";

		html += '<div class="cfgstep__cards">';

		/* The offer. The price leads, because it is the thing being weighed, and the
		   card itself is inert — clicking a whole panel to choose it was guesswork,
		   especially with a real button sitting in the bar below. Its headline is
		   authored in the Desk and carries emphasis markup, which is why that goes in
		   as HTML while everything a visitor could influence does not. */
		html +=
			'<div class="cfgcard cfgcard--yes">' +
			'<div class="cfgcard__top"><span class="cfgcard__price">' +
			esc(plans[to].step) + esc(plans[to].period) + "</span></div>" +
			(head.headline ? '<div class="cfgcard__head">' + head.headline + "</div>" : "") +
			(head.detail ? '<p class="cfgcard__d">' + esc(head.detail) + "</p>" : "");

		if (head.points && head.points.length) {
			html +=
				"<ul class=\"cfgcard__points\">" +
				head.points
					.map(function (point) {
						return (
							"<li><b>" + esc(point.heading) + "</b>" +
							(point.body ? "<span>" + esc(point.body) + "</span>" : "") + "</li>"
						);
					})
					.join("") +
				"</ul>";
		}

		if (rest.length) {
			html +=
				'<div class="cfgcard__also"><b>' + esc(text.also) + "</b><ul>" +
				rest
					.map(function (key) {
						var f = detail[key];
						return (
							"<li><b>" + esc(f.label) + "</b>" +
							(f.detail ? "<span>" + esc(f.detail) + "</span>" : "") + "</li>"
						);
					})
					.join("") +
				"</ul></div>";
		}

		html +=
			'<div class="cfgcard__foot"><button class="cfgcard__btn" type="button" ' +
			'data-answer="yes" data-step="' + index + '">' +
			esc(taken ? text.remove : fill(text.add, plans[to].name)) +
			"</button></div>" +
			// Said once, when it is chosen, and then the page moves on.
			(taken && index === flashed
				? '<div class="cfgcard__done">' + esc(fill(text.confirm, plans[chosen].name)) + "</div>"
				: "") +
			"</div>";

		// The decline. Same weight as the offer, so saying no is not a trick shot.
		html +=
			'<div class="cfgcard cfgcard--no"><button class="cfgcard__btn" type="button" ' +
			'data-answer="no" data-step="' + index + '">' + esc(text.decline) + "</button></div>";

		return html + "</div></section>";
	}

	function paintSteps() {
		var rungs = ladder();
		if (answered >= rungs.length) answered = rungs.length - 1;
		stepHost.innerHTML = rungs
			.map(function (rung, index) {
				return stepMarkup(rung, index);
			})
			.join("");

		// The stage follows the step you are being asked about: the first one still
		// open, or the last one you answered when they are all done.
		var open = rungs[Math.min(answered + 1, rungs.length - 1)];
		setStage(open ? detail[open.added[0]] : null);

		if (summary) summary.classList.toggle("is-waiting", answered < rungs.length - 1);
	}

	/* An empty field hides everything the answer would fill in. Emptied again, the page
	   folds back to the question. */
	function showWhenAnswered() {
		var empty = input.value.trim() === "";
		if (shell) shell.classList.toggle("is-empty", empty);
		if (bar) bar.classList.toggle("is-empty", empty);
	}

	function paint() {
		if (chosen < floor) chosen = floor;
		paintPanels();
		paintSteps();
	}

	/* Move to the next question a moment after one is answered, so the page keeps
	   its momentum without parking on a confirmation nobody needs to read twice.

	   Cancelled the instant the visitor does anything themselves — the one way to make
	   this hostile is to scroll the page out from under somebody who was still reading.
	   Listening for wheel/touch/key rather than "scroll" is deliberate: our own smooth
	   scroll fires scroll events, and would otherwise cancel itself. */
	var REDUCED =
		window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	function stopAdvancing() {
		if (advancing) {
			clearTimeout(advancing);
			advancing = null;
		}
	}

	["wheel", "touchmove", "keydown", "pointerdown"].forEach(function (event) {
		window.addEventListener(event, stopAdvancing, { passive: true });
	});

	function advance(index) {
		stopAdvancing();
		advancing = setTimeout(function () {
			advancing = null;
			var next = stepHost.querySelector('.cfgstep[data-step="' + (index + 1) + '"]');
			var target = next || document.getElementById("cfgSummary");
			if (!target) return;
			target.scrollIntoView({ behavior: REDUCED ? "auto" : "smooth", block: "start" });
		}, 1400);
	}

	stepHost.addEventListener("click", function (event) {
		var button = event.target.closest(".cfgcard__btn");
		if (!button) return;
		var index = parseInt(button.getAttribute("data-step"), 10);
		var section = button.closest(".cfgstep");
		var to = parseInt(section.getAttribute("data-to"), 10);
		if (isNaN(index) || isNaN(to)) return;

		var accepted = button.getAttribute("data-answer") === "yes";
		if (accepted) {
			// Pressing the button on an offer you already took is how you undo it.
			chosen = chosen >= to ? Math.max(floor, to - 1) : to;
		} else if (chosen >= to) {
			// Declining leaves the plan where it is, and opens the next question anyway
			// — a "no" here is not the end of the conversation.
			chosen = Math.max(floor, to - 1);
		}
		flashed = chosen >= to ? index : -1;
		answered = Math.max(answered, index);
		paint();
		advance(index);
	});

	function recount() {
		var ops = parseInt(input.value, 10);
		var was = floor;
		floor = floorFor(isNaN(ops) ? 0 : ops);
		// Moving the floor carries the selection with it rather than throwing away an
		// upgrade already chosen, and re-opens the ladder from the top.
		if (chosen === was || chosen < floor) chosen = floor;
		answered = -1;
		flashed = -1;
		stopAdvancing();
		paint();
		showWhenAnswered();
	}

	input.addEventListener("input", recount);
	input.addEventListener("change", recount);

	// A browser restoring the field on back/forward brings its number with it.
	var restored = parseInt(input.value, 10);
	floor = floorFor(isNaN(restored) ? 0 : restored);
	chosen = floor;
	paint();
	showWhenAnswered();
});

/* ---- documentation search ----------------------------------------------
   Type-ahead over the docs, scoped to the language of the page you are on.

   The previous version downloaded a 147 KB index to every visitor before
   they could type, and each page hardcoded which language's index to fetch.
   This asks the server, which already knows both. The form still submits
   normally, so search works with JavaScript switched off — the chips are
   plain links to ?q= and the server renders those results.
   ------------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
	var input = document.getElementById("dlSearch");
	var results = document.getElementById("dlResults");
	var browse = document.getElementById("dlBrowse");
	if (!input || !results) return;

	var lang = input.getAttribute("data-lang") || "en";
	var timer = null;
	var inFlight = null;
	var selected = -1;

	function cards() {
		return [].slice.call(results.querySelectorAll(".dl-card"));
	}

	function highlight(index) {
		var all = cards();
		if (!all.length) return;
		selected = (index + all.length) % all.length;
		all.forEach(function (card, i) {
			card.setAttribute("aria-selected", i === selected ? "true" : "false");
		});
		all[selected].scrollIntoView({ block: "nearest" });
	}

	function show(html, expanded) {
		results.innerHTML = html;
		results.hidden = !expanded;
		if (browse) browse.hidden = expanded;
		input.setAttribute("aria-expanded", expanded ? "true" : "false");
		selected = -1;
	}

	function escapeText(value) {
		var d = document.createElement("div");
		d.textContent = value;
		return d.innerHTML;
	}

	function render(query, hits) {
		if (!hits.length) {
			show('<p class="dl-empty">No results for “' + escapeText(query) + "”.</p>", true);
			return;
		}
		var head =
			'<div class="dl-rhead">' +
			hits.length +
			" result" +
			(hits.length === 1 ? "" : "s") +
			" for “" +
			escapeText(query) +
			"”</div>";
		var body = hits
			.map(function (hit) {
				// snippet is server-escaped apart from its <mark> tags.
				return (
					'<a class="dl-card" href="' +
					hit.route +
					'"><div class="sec">' +
					escapeText(hit.section) +
					"</div><h3>" +
					escapeText(hit.title) +
					"</h3><p>" +
					hit.snippet +
					"</p></a>"
				);
			})
			.join("");
		show(head + '<div class="dl-cards">' + body + "</div>", true);
	}

	function run() {
		var query = input.value.trim();

		if (!query) {
			show("", false);
			return;
		}

		if (inFlight) inFlight.abort();
		inFlight = new AbortController();

		fetch(
			"/api/method/garmentflow_cloud.docs_site.search_docs?q=" +
				encodeURIComponent(query) +
				"&lang=" +
				encodeURIComponent(lang),
			{ signal: inFlight.signal, headers: { Accept: "application/json" } }
		)
			.then(function (r) {
				return r.json();
			})
			.then(function (payload) {
				render(query, payload.message || []);
			})
			.catch(function (e) {
				// An aborted request is the expected outcome of typing another character.
				if (e.name !== "AbortError") show("", false);
			});
	}

	input.addEventListener("input", function () {
		clearTimeout(timer);
		timer = setTimeout(run, 180);
	});

	input.addEventListener("keydown", function (e) {
		if (e.key === "ArrowDown") {
			e.preventDefault();
			highlight(selected + 1);
		} else if (e.key === "ArrowUp") {
			e.preventDefault();
			highlight(selected - 1);
		} else if (e.key === "Escape") {
			input.value = "";
			show("", false);
		} else if (e.key === "Enter") {
			// Enter goes straight to the best match rather than reloading onto a results page.
			var all = cards();
			var target = all[selected >= 0 ? selected : 0];
			if (target) {
				e.preventDefault();
				window.location.href = target.getAttribute("href");
			}
		}
	});
});

/* ---- documentation sidebar ---------------------------------------------
   Bring the page you are on into view. The open section can be longer than
   the sidebar, so the highlighted item is often below the fold on arrival —
   which defeats the point of highlighting it.
   ------------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
	var nav = document.querySelector(".docs-nav");
	var current = nav && nav.querySelector('li a[aria-current="page"]');
	if (!nav || !current) return;

	var navBox = nav.getBoundingClientRect();
	var itemBox = current.getBoundingClientRect();

	if (itemBox.top < navBox.top || itemBox.bottom > navBox.bottom) {
		// scrollIntoView would move the whole page; only the sidebar should move.
		nav.scrollTop = current.offsetTop - nav.clientHeight / 2;
	}
});

/* Collapse the documentation sidebar on small screens. It ships open so that a desktop
   reader — and anyone without JavaScript — sees the full contents; on a phone that would
   push the article twenty links down the page. */
document.addEventListener("DOMContentLoaded", function () {
	var browse = document.querySelector(".docs-nav__browse");
	if (browse && window.matchMedia("(max-width: 900px)").matches) {
		browse.open = false;
	}
});

/* ---- documentation: progress, contents rail, sidebar filter -------------
   Everything structural — heading ids, breadcrumbs, prev/next, the rail's
   contents — is rendered on the server. This only adds the parts that
   genuinely need to react to the reader: how far down they are, which
   heading they are in, and what they typed in the filter.
   ------------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
	/* -- how much is left ------------------------------------------------ */
	var bar = document.querySelector(".docs-progress__bar");

	if (bar) {
		var tick = function () {
			var max = document.documentElement.scrollHeight - window.innerHeight;
			var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
			bar.style.width = Math.min(100, Math.max(0, pct)) + "%";
		};
		window.addEventListener("scroll", tick, { passive: true });
		window.addEventListener("resize", tick);
		tick();
	}

	/* -- which section am I in ------------------------------------------- */
	// The headings list moved out of the right rail and into the sidebar, under the
	// active page.
	var tocLinks = [].slice.call(document.querySelectorAll(".docs-nav__page a[data-heading]"));

	if (tocLinks.length && "IntersectionObserver" in window) {
		var byId = {};
		var headings = [];

		tocLinks.forEach(function (link) {
			var target = document.getElementById(link.getAttribute("data-heading"));
			if (target) {
				byId[target.id] = link;
				headings.push(target);
			}
		});

		var mark = function (id) {
			if (byId[id] && byId[id].classList.contains("is-current")) return;
			tocLinks.forEach(function (l) {
				l.classList.remove("is-current");
			});
			if (byId[id]) {
				byId[id].classList.add("is-current");
				byId[id].setAttribute("aria-current", "true");
			}
		};

		// Track the last heading to cross the top rather than whatever is merely visible:
		// with several short sections on screen at once, "is intersecting" flickers.
		var io = new IntersectionObserver(
			function () {
				var line = 120;
				var above = headings.filter(function (h) {
					return h.getBoundingClientRect().top <= line;
				});
				var active = above.length ? above[above.length - 1] : headings[0];
				if (active) mark(active.id);
			},
			{ rootMargin: "-100px 0px -60% 0px", threshold: [0, 1] }
		);

		headings.forEach(function (h) {
			io.observe(h);
		});
		window.addEventListener(
			"scroll",
			function () {
				var line = 120;
				var above = headings.filter(function (h) {
					return h.getBoundingClientRect().top <= line;
				});
				mark((above.length ? above[above.length - 1] : headings[0]).id);
			},
			{ passive: true }
		);
	}

	/* -- filter the contents --------------------------------------------- */
	var filter = document.getElementById("docsNavFilter");
	var nav = document.querySelector(".docs-nav");

	if (filter && nav) {
		var sections = [].slice.call(nav.querySelectorAll(".docs-nav__section"));
		var loose = [].slice.call(nav.querySelectorAll(".docs-nav__loose"));
		var defaults = sections.map(function (s) {
			return s.open;
		});
		var empty = document.createElement("p");
		empty.className = "docs-nav__empty";
		empty.textContent = filter.getAttribute("data-empty") || "Nothing matches";
		empty.hidden = true;
		filter.parentNode.parentNode.insertBefore(empty, filter.parentNode.nextSibling);

		var apply = function () {
			var q = filter.value.trim().toLowerCase();
			var anyHit = false;

			var run = function (container, isSection, index) {
				var hits = 0;
				[].slice.call(container.querySelectorAll("li")).forEach(function (li) {
					var link = li.querySelector("a");
					var match = !q || (link && link.textContent.toLowerCase().indexOf(q) >= 0);
					li.hidden = !match;
					if (match) hits++;
				});
				container.hidden = q ? hits === 0 : false;
				if (isSection) container.open = q ? hits > 0 : defaults[index];
				if (hits) anyHit = true;
			};

			loose.forEach(function (c) {
				run(c, false);
			});
			sections.forEach(function (s, i) {
				run(s, true, i);
			});
			empty.hidden = !q || anyHit;
		};

		filter.addEventListener("input", apply);
		filter.addEventListener("search", apply);
	}
});

/* A partner's link: /anything?ref=CODE. Remembered in the browser, so a visitor who reads the
   pricing page first still arrives at sign-up with their partner's code filled in. */
(function () {
	var ref = new URLSearchParams(window.location.search).get("ref");
	if (!ref || !/^[A-Za-z0-9-]{3,40}$/.test(ref)) return;
	try {
		localStorage.setItem("gf_partner_ref", ref.toUpperCase());
	} catch (e) {
		/* storage blocked: the ?ref= on /signup itself still works */
	}
})();
